export default __webpack_public_path__ + "static/media/u_list-ui-alt.8c3b773e.svg";